import ActionTypes from '../action-types';
import { onFulfill, onPending, onReject } from '../util/actions';

const initialState = {
  isDeviceReady: false,
  isLoading: false,
  isWorkerReady: false,
  token: null,
  capabilityToken: null
};

export default (state = initialState, action = {}) => {
  const { payload, type } = action;

  switch (type) {
    case onFulfill(ActionTypes.GET_AGENT_TOKEN):
      return {
        ...state,
        isLoading: false,
        token: payload.token
      };

    case onFulfill(ActionTypes.GET_AGENT_CAPABILITY_TOKEN):
      return {
        ...state,
        isLoading: false,
        capabilityToken: payload.token
      };

    case ActionTypes.INIT_DEVICE:
    case ActionTypes.INIT_WORKER:
    case onPending(ActionTypes.GET_AGENT_TOKEN):
    case onPending(ActionTypes.GET_AGENT_CAPABILITY_TOKEN):
      return {
        ...state,
        isLoading: true
      };

    case ActionTypes.DEVICE_READY:
      return {
        ...state,
        isLoading: false,
        isDeviceReady: true
      };

    case ActionTypes.WORKER_READY:
      return {
        ...state,
        isLoading: false,
        isWorkerReady: true
      };

    case onReject(ActionTypes.GET_AGENT_TOKEN):
    case onReject(ActionTypes.GET_AGENT_CAPABILITY_TOKEN):
      return {
        ...state,
        isLoading: false
      };

    default:
      return state;
  }
};
